module.exports = __webpack_public_path__ + "static/img/banner_1.ef76d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/banner_1.png
// module id = BpK1
// module chunks = 19